<template>
  <div>
    <!-- Breadcrumb -->
    <app-breadcrumb>
      <template #contentright>
        <b-button
          variant="outline-primary"
          :to="{ name: 'departments-add' }"
        >
          <span class="text-nowrap">
            <feather-icon icon="PlusCircleIcon" /> {{ $t('Add New') }}
          </span>
        </b-button>
        <b-button-group class=" ml-1">
          <b-button
            v-b-tooltip
            :variant="layout == 'tree' ? 'outline-danger' : 'outline-primary'"
            class="btn-icon"
            title="Giao diện cây"
            @click="switchLayout"
          >
            <feather-icon icon="GitMergeIcon" />
          </b-button>
          <b-button
            v-b-tooltip
            :variant="layout == 'list' ? 'outline-danger' : 'outline-primary'"
            class="btn-icon"
            title="Giao diện lưới"
            @click="switchLayout"
          >
            <feather-icon icon="ListIcon" />
          </b-button>
        </b-button-group>
      </template>
    </app-breadcrumb>

    <!-- Filters -->
    <department-list-filters
      v-if="layout == 'list'"
      :department-filter.sync="departmentFilter"
      :department-filter-is-director.sync="departmentFilterIsDirector"
      :status-filter.sync="statusFilter"
      :search-query.sync="searchQuery"
      :department-options="departmentOptions"
      :status-options="statusOptions"
    />

    <!-- Table Container Card -->
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <department-layout-list
        v-if="layout == 'list'"
        :items-data="itemsData"
        :total-entries="totalEntries"
        :current-page.sync="currentPage"
        :per-page.sync="perPage"
      />
      <department-layout-tree
        v-else
        :items-data-tree="itemsDataTree"
        :loading.sync="loading"
        @reload-data="reloadData"
      />
    </b-overlay>
  </div>
</template>

<script>
import {
  BOverlay, BButton, BButtonGroup, VBTooltip,
} from 'bootstrap-vue'
import { ref, watch } from '@vue/composition-api'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import Ripple from 'vue-ripple-directive'
import DepartmentListFilters from './DepartmentListFilters.vue'
import useDepartments from './useDepartments'
import DepartmentLayoutList from './DepartmentLayoutList.vue'
import DepartmentLayoutTree from './DepartmentLayoutTree.vue'

export default {
  components: {
    AppBreadcrumb,
    DepartmentListFilters,
    BOverlay,
    BButton,
    BButtonGroup,
    DepartmentLayoutList,
    DepartmentLayoutTree,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  setup() {
    const layout = ref('tree')
    const switchLayout = () => {
      layout.value = layout.value === 'list' ? 'tree' : 'list'
    }

    // const itemsDataOptions = ref([])

    const {
      loading,
      fetchDepartments,
      fetchDepartmentTree,
      departmentOptions,
      statusOptions,
      departmentFilter,
      departmentFilterIsDirector,
      statusFilter,
      searchQuery,
      itemsData,
      itemsDataTree,
      totalEntries,
      perPage,
      currentPage,

    } = useDepartments()

    fetchDepartments();
    fetchDepartmentTree();

    return {
      loading,
      departmentOptions,
      statusOptions,
      departmentFilter,
      departmentFilterIsDirector,
      statusFilter,
      searchQuery,
      itemsData,
      itemsDataTree,
      totalEntries,
      currentPage,
      perPage,
      layout,
      switchLayout,
      fetchDepartmentTree,
    }
  },
  methods: {
    reloadData() {
      this.fetchDepartmentTree();
    },
  },
}
</script>
<style lang="scss" >
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
